import { useTheme } from '@material-ui/core';
import React from 'react';
import Plot from 'react-plotly.js';

export type Bins = { start: number; end: number; size: number };

interface Props {
  min: number;
  max: number;
  dataInRange: number[];
  dataNotInRange: number[];
  bins: Bins;
  width?: number;
  height?: number;
}

const FilterHistogram = ({ min, max, dataInRange, dataNotInRange, bins, width, height }: Props) => {
  const theme = useTheme();

  return (
    <Plot
      data={[
        {
          type: 'histogram',
          x: dataInRange,
          xbins: bins,
          marker: { color: theme.palette.primary.main },
        },
        {
          type: 'histogram',
          x: dataNotInRange,
          xbins: bins,
          opacity: 0.4,
          marker: { color: theme.palette.primary.light },
        },
      ]}
      layout={{
        width,
        height,
        margin: { t: 0, r: 0, b: 0, l: 0, pad: 0 },
        xaxis: { range: [min, max] },
        bargap: 0.1,
        barmode: 'stack',
        showlegend: false,
      }}
      config={{ staticPlot: true }}
    />
  );
};

export default FilterHistogram;
